<template>
  <div class="body1">
    <div style=" border:2px firebrick solid;padding: 8px;border-radius:15px; ">
    <el-form style="
    background-image: url('../../../static/bg2.jpg');
border: 8px firebrick solid;border-radius:14px;"  :model="form1"  ref="form1" label-width="100px" class="demo-ruleForm" >
                <div style="font-size: 35px;font-weight: bold;text-align: center;margin-bottom: 20px;color: firebrick;padding-top: 70px;">企业信用信息</div>
                 <div style="font-size: 18px;font-weight: bold;text-align: left;margin-left:70px;margin-bottom: 5px;color: firebrick;padding-top: 10px;">企业信用信息</div>
                   <el-form-item>
                     <label  class="btn">企业名称：</label>
                     <label >{{form1.eName}}</label>
                   </el-form-item>
                   <el-form-item class="yh">
                     <label class="btn">评价类型：</label>
                     <label >{{form1.gradeType}}</label>
                   </el-form-item>
                 <el-form-item class="yh">
                     <label class="btn">信用等级：</label>
                     <label >{{form1.creditRegistration}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">证书编号：</label>
                     <label >{{form1.certificateNumber}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">评级时间：</label>
                     <label >{{form1.appraiseDate}}</label>
                   </el-form-item>
                  <el-form-item>
                     <label class="btn">有效期至：</label>
                     <label >{{form1.term}}</label>
                   </el-form-item>
                 <div style="font-size: 18px;font-weight: bold;text-align: left;margin-left:70px;margin-bottom: 5px;color: firebrick;padding-top: 10px;">企业基本信息</div>
                 <el-form-item>
                     <label class="btn">统一社会信用代码：</label>
                     <label >{{form1.eCode}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">法定代表人：</label>
                     <label >{{form1.jperson}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">联系电话：</label>
                     <label >{{form1.tel}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">地址：</label>
                     <label >{{form1.eAddr}}</label>
                   </el-form-item>
                  <el-form-item>
                     <label class="btn">营业期限：</label>
                     <label >{{form1.managementTimeend}}</label>
                   </el-form-item>

                  <el-form-item>
                     <label class="btn">经营范围：</label>
                     <label >{{form1.managementScope}}</label>
                   </el-form-item>

                  <el-form-item>
                     <label class="btn">登记机关：</label>
                     <label >{{form1.registerDept}}</label>
                   </el-form-item>
                 <el-form-item>
                     <label class="btn">评级机构：</label>
                     <label >{{form1.organization}}</label>
                   </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'creditdetails',
  data () {
    return {
      showHeader: false,
      formInline: {
        searchname: ''
      },
      form1: {},
      pid: ''
    }
  },

  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/public/details?id=' + that.$route.query.pid).then(function (response) {
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa'); alert('失败')
    })
  }
}
</script>

<style >
.body1{
  width:650px;
  margin: 0 auto;}

  .btn{
    font-weight: bold;
  }
  .yh{}
</style>



// WEBPACK FOOTER //
// src/components/computer/creditdetails.vue